let currentToken: string | null = null;

type Listener = () => void;
const listeners = new Set<Listener>();

/** Set by the active auth mode (OIDC user-loaded, dev-auth injection, etc.). */
export function setToken(token: string | null): void {
  if (token === currentToken) return;
  currentToken = token;
  for (const listener of listeners) listener();
}

/** Read synchronously by RTK Query's prepareHeaders. */
export function getToken(): string | null {
  return currentToken;
}

/**
 * Subscribe to token changes, so components deriving state from the token (e.g.
 * the admin-role check) re-render when it is replaced or cleared instead of
 * holding a stale answer. Returns an unsubscribe function — the shape
 * `useSyncExternalStore` expects.
 */
export function subscribeToToken(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
